module.exports = __webpack_public_path__ + "static/heroBg-06e735a05f3d760fb481554f8c59147b.png";